<template>
<div container--fluid>
    <v-layout>
        <RefereeModule></RefereeModule>
    </v-layout>
</div>
</template>

<script>
import RefereeModule from '@modules/referee/index.vue';

export default {
    name: 'referee',
    components: {
        RefereeModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
